<div class="my-3 my-md-5">
    <div class="container-fluid">
        <div class="col-sm-6 float-left">
            <h1 class="page-title">Master Pin Code List</h1>
        </div>
        <div class="col-sm-6 float-left add_user_btn">
            <a class="btn btn-success mr-3" (click)="showModal()"><i class="fa fa-file-excel"></i> Import Pincode</a>
            <a routerLink="/create-pin-code" class="btn btn-success">
                <i class="fa fa-plus" aria-hidden="true"></i> Add Pin Code
            </a>
            <br>
            <a href="{{sc3Url}}crm/master_pincode_data.csv" target="_blank">Sample CSV for Import Pincode</a>
        </div>
    </div>

    <div class="container-fluid px-4 pt-4 card">
        <mat-accordion class="example-headers-align" multi>
            <mat-expansion-panel>
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <i class="fas fa-sliders-h"></i> <span class="pl-2">Filters</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="row mb-4 mt-4">
                    <div class="col-sm-3">
                        <mat-select (selectionChange)="getCircleZone($event.value)" placeholder="Circle"
                            [(ngModel)]="circle" (click)="setSearchValue('circle')">
                            <input class="mySearchInput" #circleSearch focused="'true'" type="text" 
                                (keyup)="searchOnSelect($event.target.value, 'circle')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="circleSearch">
                            <mat-option>All</mat-option>
                            <mat-option [value]="cir.id" *ngFor="let cir of circles">{{cir.name}}
                            </mat-option>
                        </mat-select>
                    </div>
                    <div class="col-sm-3">
                        <mat-select  placeholder="Zone"
                            [(ngModel)]="zone" [disabled]="circle_zone" (click)="setSearchValue('zone')">
                            <input class="mySearchInput" #zoneSearch focused="'true'" type="text" 
                                (keyup)="searchOnSelect($event.target.value, 'cities')"
                                (keydown)="$event.stopPropagation()" autocomplete="off" placeholder="Search"
                                id="zoneSearch">
                            <mat-option [value]="zone.id" *ngFor="let zone of zones">
                                {{zone.zone_name}}
                            </mat-option>
                        </mat-select>
                    </div>

                    <div class="col-sm-3">
                        <input class="form-control"  type="text" [(ngModel)]="search_pincode"  onkeypress="if (this.value.length > 7) return false;" placeholder="Search pin code" />
                    </div>
                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="loadPinCodeList(0,perpage)">
                        <i class="fa fa-search" aria-hidden="true"></i> Search Data</button>
                    <button type="button" class="btn btn-primary ml-2 mb-4" (click)="resetFilters()"> <i
                            class="fa fa-sync"></i> Reset Filters</button>

                </div>

            </mat-expansion-panel>
        </mat-accordion>
        <div class="card">
            <div class="container-fluid row">
                <div class="col-sm-6 p-3"><button type="button" class="btn btn-success" [disabled]="loading"
                        (click)="loadPinCodeList(0,perpage)"><i class="fa fa-sync" [ngClass]="{'fa-spin':loading}"></i>
                        Refresh List</button>
                        <button  type="button" class="btn btn-success ml-2" [disabled]="loading" (click)="exportPinCodeList()"><i class="fa fa-file-excel"></i> Export List</button>
                    </div>
                <div class="col-sm-6">
                    <mat-paginator #paginatorTop [length]="length" [pageSizeOptions]="pageSizeOptions"
                        [pageSize]="perpage"
                        (page)="pageEvent = getServerData($event);paginatorBottom.pageIndex = $event.pageIndex">
                    </mat-paginator>
                </div>
            </div>
            <div class="tableFixHead" style="overflow: scroll">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 50px;">#</th>
                            <th>Circle</th>
                            <th>Zone</th>
                            <th>Pin Code</th>
                            <th style="width: 100px;">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let PinCode of pincodeList;let index = index;">
                            <td>{{(pageIndex*perpage)+index+1}}</td>
                            <td>{{PinCode.circle_name}} </td>
                            <td>{{PinCode.zoneName}} </td>
                            <td>{{PinCode.pincode}} </td>
                            <td>
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle" type="button"
                                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Action
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" routerLink="/update-pin-code/{{PinCode.id}}"><i
                                                class="fa fa-pen"></i> Update</a>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="loading">
                            <td colspan="5" class="text-center"><i class="fa fa-spin fa-spinner fa-2x"></i></td>
                        </tr>
                        <tr *ngIf="loaded && !pincodeList.length">
                            <td colspan="5" ><i class="far fa-frown"></i> Data not found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <mat-paginator #paginatorBottom [length]="length" [pageSizeOptions]="pageSizeOptions" [pageSize]="perpage"
                (page)="pageEvent = getServerData($event);paginatorTop.pageIndex = $event.pageIndex"></mat-paginator>
        </div>


    </div>
</div>



<div class="modal fade" id="myModal" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Import Pin Code </h4>
                <button type="button" class="close" (click)="hideModal()"></button>
            </div>
            <!-- Modal body -->
            <div class="modal-body">
                <div class="form-group">
                    <div class="row">
                        <label class="col-sm-12">Upload CSV</label>
                        <input [disabled]="submitted" type="file" #csvUpload (change)="selectFile($event)"
                            class="form-control" />
                    </div>
                    <span *ngIf="submitted"><i class="fa fa-spin fa-spinner"></i> Uploading...</span>
                </div>
                <div class="form-group" [innerHTML]="uploaded_msg | safe:'html'">

                </div>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn" (click)="hideModal()">Close</button>
            </div>
        </div>
    </div>
</div>